import _                                  from 'underscore';
import React, { FC }                      from 'react';
import styled                             from 'styled-components';
import { CorvalUIColor, SemanticUIColor } from '../../../../types';
import { getCSSVar }                      from '../../../../util/BrowserUtility';

export interface DotShapeProps {
	size?: number,
	color?:
		string
		| SemanticUIColor
		| CorvalUIColor.WHITE
		| CorvalUIColor.GRAY
		| CorvalUIColor.OBSIDIAN
		| CorvalUIColor.ONYX
		| CorvalUIColor.LIGHTBLACK
		| CorvalUIColor.LIGHTBLUE
		| CorvalUIColor.LIGHTGREEN
		| CorvalUIColor.LIGHTORANGE
		| CorvalUIColor.LIGHTPINK
		| CorvalUIColor.LIGHTOLIVE
		| CorvalUIColor.LIGHTPURPLE
		| CorvalUIColor.LIGHTRED
		| CorvalUIColor.LIGHTTEAL
		| CorvalUIColor.LIGHTYELLOW
		| CorvalUIColor.BLUEBACKGROUND
		| CorvalUIColor.GREENBACKGROUND
		| CorvalUIColor.ORANGEBACKGROUND
		| CorvalUIColor.PINKBACKGROUND
		| CorvalUIColor.OLIVEBACKGROUND
		| CorvalUIColor.PURPLEBACKGROUND
		| CorvalUIColor.REDBACKGROUND
		| CorvalUIColor.TEALBACKGROUND
		| CorvalUIColor.YELLOWBACKGROUND
		| CorvalUIColor.DARKBLUE
		| CorvalUIColor.DARKGREEN
		| CorvalUIColor.DARKORANGE
		| CorvalUIColor.DARKPINK
		| CorvalUIColor.DARKOLIVE
		| CorvalUIColor.DARKPURPLE
		| CorvalUIColor.DARKRED
		| CorvalUIColor.DARKTEAL
		| CorvalUIColor.DARKYELLOW
		| CorvalUIColor.OFFWHITE
		| CorvalUIColor.DARKWHITE
		| CorvalUIColor.LIGHTGREY,

	[ additionalProps: string ]: any
}

const defaultProps: DotShapeProps = {
	size:  100,
	color: SemanticUIColor.TEAL,
}

const Dot = styled.span<DotShapeProps>`
	position: relative;
	display: inline-block;
    width: ${ props => props.size }px;
    height: ${ props => props.size }px;
    background: ${ props => props.color };
    border-radius: 50%;
`;

const DotShape: FC<DotShapeProps> = ( props ) => {

	let color = getCSSVar( `--color-${ props.color }`, props.color ),
	    size  = props.size;

	return <Dot size={ size } color={ color }/>;
};

DotShape.defaultProps = defaultProps;

export { DotShape }
